import { render, staticRenderFns } from "./addEditModal.vue?vue&type=template&id=c2f2a568&"
import script from "./addEditModal.vue?vue&type=script&lang=js&"
export * from "./addEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports